module.exports = __webpack_public_path__ + "static/media/cu.d8a3c08d.svg";